import React from 'react'

import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  Menu,
  MenuItem,
} from '@mui/material'

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { useAuth } from '../../pages/Auth'

type SearchBarProps = TextFieldProps & {
  onChangeText: (text: string) => void
  onAddNewSite: () => void
}

function SearchBar({ onChangeText, onAddNewSite, ...props }: SearchBarProps) {
  const { isAdmin } = useAuth()

  return (
    <TextField
      id="search-bar"
      onChange={(e) => {
        e.preventDefault()
        onChangeText(e.target.value)
      }}
      variant="filled"
      size="small"
      fullWidth
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {isAdmin && <SearchBarDropDown onAddNewSite={onAddNewSite} />}
          </InputAdornment>
        ),
      }}
    />
  )
}

interface SearchBarDropDownProps {
  onAddNewSite: () => void
}

function SearchBarDropDown({ onAddNewSite }: SearchBarDropDownProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton
        aria-haspopup="menu"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <KeyboardArrowDownIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={() => {
            onAddNewSite()
            handleClose()
          }}
        >
          Add new site
        </MenuItem>
      </Menu>
    </div>
  )
}

export default SearchBar
